<template>
           <!-- Masthead-->
        <header class="masthead">
            <div class="color-overlay">
                <div class="container">
                    <div class="masthead-heading text-uppercase">Schade, dass Sie uns verlassen</div> 
                    <!-- <div class="masthead-subheading">Wir freuen uns Sie baldmöglichst </div>  -->
                    <div class="masthead-subheading"> Besuchen Sie uns bald wieder</div>
                    <!-- Signup-->
                    <div class="row">
                        <div class="col-md-10 col-lg-8 mx-auto text-center">
                            <i class="far fa-paper-plane fa-2x mb-2 text-white"></i>
                            <h2 class="text-white mb-5">BARRIEREN-NEWSLETTER ABBESTELLEN?</h2>
                            <form class="form-inline d-flex" id="newsletter" name="addNewsletter" v-on:submit.prevent="checkForm" novalidate="true">
                              <input class="form-control flex-fill mr-0 mr-sm-2 mb-3 mb-sm-0" v-model="email" type="email" name="email" placeholder="E-Mail-Adresse..." />
                              <button class="btn btn-primary mx-auto" data-action='submit' :disabled="isSending">Abbestellen</button>
                              <small class="text-muted">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and<a href="https://policies.google.com/terms" target="_blank"> Terms of Service</a> apply.</small>
                            </form>
                            <div class="text-center">
                                <div v-show='isHidden'>
                                  <div v-if="errors.length" class='alert alert-danger'>
                                    <button v-on:click="isHidden = false" type='button' class='close' aria-hidden='true'>&times;</button>
                                    <strong v-for="(error, key) in errors" :key=key>
                                    {{ error }}
                                    </strong>
                                  </div>
                                  <div v-if="successes.length" class='alert alert-success'>
                                    <button v-on:click="isHidden = false" type='button' class='close' aria-hidden='true'>&times;</button>
                                    <strong v-for="(success, key) in successes" :key=key>
                                    {{ success }}
                                    </strong>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
</template>

<script src="https://www.google.com/recaptcha/api.js?render=6LefjgAVAAAAAK_bpnU861UmVVQuqXIP8i56yC-A"></script>

<script>
export default {
    data(){
      return{
          isHidden: true,
          isSending: false,
          successes: [],
          errors: [],
          email: null,
          barJSON: [
              {
                  img: require('../assets/img/bar/1.jpg'),
                  caption: 'Illustration',
                  title: 'Unser Lokal'
              }
          ]
      }
    },

    methods: {
    checkForm: function (e) {
      this.isSending = true;
      this.errors = [];
      this.successes = [];

      if (!this.email) {
        this.errors.push('Bitte gib deine Email Adresse ein.');
        this.isSending = false
        this.isHidden = true
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Bitte gib eine gültige Email Adresse ein.');
        this.isSending = false
        this.isHidden = true
      }

      if (!this.errors.length) {
        grecaptcha.ready(function() {
          grecaptcha.execute('6LefjgAVAAAAAK_bpnU861UmVVQuqXIP8i56yC-A', {action: 'submit'}).then(function(token) {
            // Add your logic to submit to your backend server here.
            var data = {
                Email: this.email,
                g_recaptcha_response: token,
            };
            this.registerNewsletter(data)
          }.bind(this));
        }.bind(this));
      } 
    },

    registerNewsletter: function(data){
        const DELNEW_API_ENDPOINT = this.$appConfig.post_api.delnew
        fetch(DELNEW_API_ENDPOINT, {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          this.isSending = false
          this.isHidden = true
          this.email = ""
          const data = response.data
          this.successes.push('Danke, Du wirst in wenigen Minuten eine Email erhalten mit der Anmeldebestätigung. Um die Anmeldung zu beenden klicke bitte auf den erhaltenen Link.');
          grecaptcha.reset();
        })
        .catch((error) => {
          this.isSending = false
          this.isHidden = true
          this.errors.push('Sorry, es scheint, dass mein Mailserver nicht antwortet. Bitte versuche es später noch einmal!');
          grecaptcha.reset();
        });
    },

    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  }
}
</script>



<style>
  .grecaptcha-badge {
      visibility: hidden; 
  }
</style> 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .color-overlay {
    padding-top: 10.5rem;
    padding-bottom: 6rem;
    background: rgba(78, 78, 77, 0.39);
  }
  @media (min-width: 768px) {
    .color-overlay {
      padding-top: 14rem;
      padding-bottom: 15.5rem;
      background: rgba(20, 20, 20, 0.63);
    }
  }
  .text-center {
    text-align: center !important;
    padding-top: 1rem !important;
  }
  .small {
    color: #6c757d !important;
  }
  a {
    color: #6c757d !important;
  }

</style>        